import React, { Component } from 'react';
import PropTypes from 'prop-types';
import isEqual from 'lodash/isEqual';
import { Image } from '@components/common';

class User extends Component {
	shouldComponentUpdate = ({
		src,
		firstName,
		lastName,
	}) => {
		const lastProps = this.props;

		return (
			!isEqual(src, lastProps.src)
			|| !isEqual(firstName, lastProps.firstName)
			|| !isEqual(lastName, lastProps.lastName)
		);
	}

	render() {
		const {
			src,
			firstName,
			lastName,
		} = this.props;

		return (
			<div className="user-container">
				<div className="image-container">
					<Image
						src={src}
						className="height-30 width-30 img-cover"
						fallbackSrc="avatar"
					/>
				</div>
				<span>
					{ firstName }
					{' '}
					{ lastName }
				</span>
			</div>
		);
	}
}

User.propTypes = {
	src       : PropTypes.string.isRequired,
	firstName : PropTypes.string.isRequired,
	lastName  : PropTypes.string.isRequired,
};

export default User;
